import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function WaveBottomTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-relaxed overflow-hidden" data-testid="resume-live-preview">
      <div className="relative pb-8" style={{ backgroundColor: accent }}>
        <div className="p-6 pb-4">
          <h1 className="text-2xl font-bold text-white">{draft.full_name || "Your Name"}</h1>
          {draft.target_role && <p className="text-white/80 text-[12px] mt-0.5">{draft.target_role}</p>}
          <p className="text-white/70 text-[11px] mt-2">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join("  •  ")}</p>
        </div>
        <svg className="absolute bottom-0 left-0 w-full" viewBox="0 0 400 20" preserveAspectRatio="none" style={{ height: "20px" }}>
          <path d="M0,10 Q100,20 200,10 T400,10 V20 H0 Z" fill="white" />
        </svg>
      </div>
      <div className="p-6 pt-2">
        {draft.summary && <p className="text-slate-700 mb-4">{draft.summary}</p>}
        {draft.experience.length > 0 && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Experience</h2>
            {draft.experience.map((e, i) => (
              <div key={i} className="mb-2.5">
                <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
              </div>
            ))}
          </div>
        )}
        {draft.education.length > 0 && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Education</h2>
            {draft.education.map((ed, i) => <p key={i} className="text-slate-700">{ed.degree} {ed.field} — {ed.school}</p>)}
          </div>
        )}
        {draft.skills.length > 0 && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Skills</h2>
            <p className="text-slate-700">{draft.skills.join(", ")}</p>
          </div>
        )}
        <ExtraResumeSections draft={draft} accent={accent} />
      </div>
    </div>
  );
}
